import { PRODUCT_IDS, TOOL_IDS } from '@adsk/alloy-provider';

import { LAYOUTS } from '../../types';

export const ACC_SHEETS_PUBLISH_LOG_REMOTE_CONFIG = {
  scope: 'accSheetsPublish',
  layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
  modulePath: './SheetsPublishLog',
  layoutProps: {
    currentToolId: TOOL_IDS.SHEETS,
    currentProductId: PRODUCT_IDS.BUILD,
  },
};

export const ACC_SHEETS_PUBLISH_FLOW_REMOTE_CONFIG = {
  scope: 'accSheetsPublish',
  layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
  modulePath: './SheetsPublishFlow',
  layoutProps: {
    currentToolId: TOOL_IDS.SHEETS,
    currentProductId: PRODUCT_IDS.BUILD,
    renderTopNavigation: () => null,
    renderSideNavigation: () => null,
  },
};
